import { render, staticRenderFns } from "./data53.vue?vue&type=template&id=cb29e4b6&scoped=true"
import script from "./data53.vue?vue&type=script&lang=js"
export * from "./data53.vue?vue&type=script&lang=js"
import style1 from "./data53.vue?vue&type=style&index=1&id=cb29e4b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb29e4b6",
  null
  
)

export default component.exports